<template>
  <div id="filtrar-bancas">
    <b-card header-tag="header" class="m-3" no-body>
      <template #header>
        <header-sagres titulo="Bancas" :botoes="botoesHeader" breakpoint="xl" />
      </template>
      <b-card-body>
        <CardFiltrosBusca>
          <b-col lg="6" class="filtro-pesquisa">
            <b-form-group label="" label-for="filter-input" label-align-sm="right" label-size="sm" class="mb-3">
              <b-input-group size="sm">
                <b-form-input id="filter-input" v-model="filter" type="search" class="search-input"
                  placeholder="Filtre por Nome, CNPJ ou Telefone" />
              </b-input-group>
            </b-form-group>
          </b-col>
        </CardFiltrosBusca>

        <b-table id="bancasTable" :fields="fields" :items="items" :busy="tableBusy" :current-page="currentPage"
          :filter="filter" hover no-border-collapse sort-by="" :sort-desc="true" striped stacked="xl" show-empty
          per-page="10" @filtered="onFiltered">
          <template #empty>
            <span>Não foram encontrados dados.</span>
          </template>
          <template #emptyfiltered>
            <span>Não foram encontrados dados.</span>
          </template>
          <template #table-busy>
            <div class="text-center text-dark">
              <b-spinner class="align-middle"></b-spinner>
              <strong class="loading-text">Carregando...</strong>
            </div>
          </template>

          <template v-slot:cell(actions)="row">
            <b-dropdown class="d-md-none" right no-caret>
              <template #button-content>
                <font-awesome-icon icon="bars" />
              </template>
              <b-dropdown-item @click="openModalBanca(row.item)">
                <font-awesome-icon icon="edit" />
                <span>Editar</span>
              </b-dropdown-item>
              <b-dropdown-item @click="alertaRemove(row.item)">
                <font-awesome-icon icon="trash" />
                <span>Excluir</span>
              </b-dropdown-item>
            </b-dropdown>
            <div class="actions-icons lgvert d-none d-md-flex justify-content-center">
              <b-link class="text-dark" @click="openModalBanca(row.item)">
                <font-awesome-icon icon="edit" />
                <div style="font-size: 12px">Editar</div>
              </b-link>
              <b-link class="text-dark" @click="alertaRemove(row.item)">
                <font-awesome-icon icon="trash" />
                <div style="font-size: 12px">Excluir</div>
              </b-link>
            </div>
          </template>

        </b-table>
        <b-pagination v-model="currentPage" :total-rows="this.totalRows" :per-page="10"
          aria-controls="bancasTable"></b-pagination>
      </b-card-body>
    </b-card>

    <validation-observer ref="validationobserver" v-slot="{ handleSubmit }">
      <b-modal id="modal-banca" :title="title" header-bg-variant="secondary" header-text-variant="light"
        @hide="closeModal" centered>
        <b-form v-if="alteracaoBanca"
          @submit.prevent="handleSubmit(alteracaoBanca.IdBanca > 0 ? editarBanca : criarBanca)">
          <b-container>
            <b-row>
              <b-col cols="12">
                <default-form-validation-provider label="Nome da banca">
                  <b-form-input v-model="alteracaoBanca.NomeBanca" placeholder="Digite o nome da banca" />
                </default-form-validation-provider>
              </b-col>
              <b-col cols="12">
                <default-form-validation-provider label="CNPJ da banca">
                  <b-form-input v-model="alteracaoBanca.CnpjBanca" type="number" placeholder="Digite o CNPJ da banca"
                    min="1" max="99999999999999" />
                </default-form-validation-provider>
              </b-col>
              <b-col cols="12">
                <default-form-validation-provider label="Telefone da banca">
                  <vue-tel-input v-model="alteracaoBanca.FoneBanca" :props="vueTelOptions"
                    :inputOptions="telPlaceholder" />
                </default-form-validation-provider>
              </b-col>
            </b-row>
          </b-container>
        </b-form>
        <template #modal-footer>
          <b-button size="sm" variant="outline-secondary" @click="closeModal">Cancelar</b-button>
          <b-button type="submit" size="sm" variant="secondary" :disabled="!alteracaoBanca.NomeBanca ||
            !alteracaoBanca.CnpjBanca ||
            alteracaoBanca.CnpjBanca.length < 14 ||
            !alteracaoBanca.FoneBanca ||
            alteracaoBanca.FoneBanca.length < 14 ||
            alteracaoBanca.FoneBanca.length > 15"
            @click="handleSubmit(alteracaoBanca.IdBanca > 0 ? editarBanca : criarBanca)">
            {{ alteracaoBanca.IdBanca > 0 ? 'Editar' : 'Adicionar' }}
          </b-button>
        </template>
      </b-modal>
    </validation-observer>

  </div>
</template>

<script lang="ts">
import { UtilsTS } from "@/utilsts";
import { mixins } from "vue-class-component";
import { TableField } from "@/types/table-field";
import { ValidationObserver } from "vee-validate";
import { BotaoSagres } from "@/types/botao-sagres";
import { Banca } from "@/types/atos-pessoal/concursos/banca";
import { Component, Ref, Vue } from "vue-property-decorator";
import HeaderSagres from "@/components/shared/HeaderSagres.vue";
import concursoService from "@/services/atos-pessoal/concursoService";
import CardFiltrosBusca from "@/components/shared/CardFiltrosBusca.vue";
import { fieldsBancas } from "@/types/atos-pessoal/concursos/fields-bancas";
import DefaultFormValidationProvider from "@/components/shared/DefaultFormValidationProvider.vue";

const CompProps = Vue.extend({
  name: "FiltrarBancas",
  components: {
    HeaderSagres,
    CardFiltrosBusca,
    ValidationObserver,
    DefaultFormValidationProvider,
  },
});

@Component
export default class FiltrarBancas extends mixins(UtilsTS, CompProps) {
  @Ref("validationobserver") validationobserver: InstanceType<typeof ValidationObserver>;
  filter = ''

  title = ''
  alteracaoBanca: Banca = {
    IdBanca: 0,
    NomeBanca: '',
    CnpjBanca: '',
    FoneBanca: ''
  }

  totalRows = 0
  currentPage = 1
  tableBusy = false

  telPlaceholder = {
    placeholder: 'Digite o telefone da banca',
  }

  items: Banca[] = []
  fields: TableField[] = fieldsBancas
  botoesHeader: BotaoSagres[] = [
    {
      id: 1,
      icone: 'plus',
      texto: 'Criar Banca',
      acao: () => this.openModalBanca()
    },
  ]

  async mounted() {
    await this.getBancas();
  }

  async getBancas() {
    try {
      this.tableBusy = true;
      const response = await concursoService.getBancas();
      if (response === null || response === undefined) return this.$toast.error("Erro ao obter a lista de Bancas");
      this.items = response
      this.totalRows = this.items.length
    } catch (error: any) {
      this.tratarError(error)
      this.items = []
      this.totalRows = 0
    } finally {
      this.tableBusy = false;
    }
  }

  async editarBanca() {
    try {
      this.tableBusy = true
      const response = await concursoService.editarBanca(this.alteracaoBanca);
      if (response) return this.$toast.error(response);
      this.$toast.success("Banca editada com sucesso");
      this.closeModal()
      this.getBancas()
    } catch (error: any) {
      this.tratarError(error)
    } finally {
      this.tableBusy = false
    }
  }

  async criarBanca() {
    try {
      this.tableBusy = true
      const response = await concursoService.criarBanca(this.alteracaoBanca);
      if (response && response.IdBanca && response.IdBanca > 0) this.$toast.success('Banca criada com sucesso');
      else return this.$toast.error(response);
      this.closeModal()
      this.getBancas()
    } catch (error: any) {
      this.tratarError(error)
    } finally {
      this.tableBusy = false
    }
  }

  openModalBanca(banca?: Banca) {
    try {
      this.tableBusy = true;
      this.$bvModal.show('modal-banca')
      banca ? this.modalEdicaoBanca(banca) : this.modalCriacaoBanca()
    } catch (error) {
      console.error(error)
    } finally {
      this.tableBusy = false;
    }
  }

  modalCriacaoBanca() {
    this.title = 'Criar Banca'
    this.alteracaoBanca = {
      IdBanca: 0,
      NomeBanca: '',
      CnpjBanca: '',
      FoneBanca: '',
    }
  }

  modalEdicaoBanca(banca: Banca) {
    this.title = 'Editar Banca'
    this.alteracaoBanca = {
      IdBanca: banca.IdBanca,
      NomeBanca: banca.NomeBanca,
      CnpjBanca: banca.CnpjBanca,
      FoneBanca: banca.FoneBanca
    }
  }

  closeModal() {
    this.$bvModal.hide('modal-banca')
  }

  alertaRemove(banca: Banca) {
    this.$bvModal.msgBoxConfirm(`Deseja remover a banca ${this.capitalize(banca.NomeBanca)} ?`, {
      buttonSize: 'sm',
      cancelTitle: 'Cancelar',
      cancelVariant: 'outline-secondary',
      okVariant: 'secondary',
      centered: true,
      headerBgVariant: 'secondary',
      headerTextVariant: 'light',
      okTitle: 'Confirmar',
      title: 'Apagar Banca',
    }).then(value => {
      if (value) this.removerBanca(banca)
    }).catch(err => {
      console.error(`Erro ao operar o dialog de alerta de remoção banca`, err)
    })
  }

  async removerBanca(banca: Banca) {
    try {
      this.tableBusy = true;
      const response = await concursoService.removerBanca(banca.IdBanca);
      if (response) return this.$toast.error(response);
      this.$toast.success("Banca removida com sucesso");
      await this.getBancas();
    } catch (error: any) {
      this.tratarError(error)
    } finally {
      this.tableBusy = false;
    }
  }

  onFiltered(filteredItems: any): any {
    this.totalRows = filteredItems.length
    this.currentPage = 1
  }
}
</script>